import React, { Component } from 'react';
import { bool, func, object, shape, string } from 'prop-types';

import CSS from './styles.css'

import Affordances from './Affordances';
import { ItemEdit as IEIcon } from 'Shared/Icons';
import { More as MRIcon } from 'Shared/Icons';


const ReadViews = ({ headerStyles, isAffordancesOpen, openAffordances, selectedHighlight }) => {
  const { darkColor, label, noteText } = selectedHighlight;

  return (
    <section className={ CSS['container'] }>
      <Affordances isOpen={ isAffordancesOpen } />

      <header className={ CSS['header'] } style={ headerStyles }>
        <IEIcon fill={ darkColor } />
        <div className={ CSS['note-label'] }>
          { label }
        </div>
        <MRIcon
          className={ CSS['more-icon'] }
          fill={ darkColor }
          onClick={ openAffordances }
          tabindex="2" />
      </header>

      <div className={ CSS['body'] }>
        <div className={ CSS['noteText'] }>{ noteText }</div>
      </div>
    </section>
  );
};

ReadViews.propTypes = {
  headerStyles: object,
  isAffordancesOpen: bool,
  openAffordances: func,
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    id: string,
    noteText: string,
    lastModifiedAt: string
  })
};


export default ReadViews;
